import React from "react";
import styles from "./ResponsiveSanityImage.module.scss";
import { SanityImage, SanityImageProps } from "../SanityImage/SanityImage";
import clsx from "clsx";
import { useDebouncedResizeObserver } from "../useDebounceResizeObserver";

export type ResponsiveSanityImageProps = SanityImageProps & {
  defaultWidth: number;
  defaultHeight: number;
};

const ResponsiveSanityImageBase: React.FC<
  React.PropsWithChildren<ResponsiveSanityImageProps>
> = ({ className, defaultWidth, defaultHeight, ...props }) => {
  const { ref, width, height } = useDebouncedResizeObserver(1000, 200);
  return (
    <React.Fragment>
      <SanityImage
        ref={ref}
        {...props}
        className={clsx([styles.responsiveImageContainer, className])}
        width={width || defaultWidth}
        height={height || defaultHeight}
        forceRenderPreview={!width && !height}
      />

      <noscript>
        <SanityImage
          loading={undefined}
          {...props}
          width={defaultWidth}
          height={defaultHeight}
        />
      </noscript>
    </React.Fragment>
  );
};

export const ResponsiveSanityImage = React.memo(ResponsiveSanityImageBase);
